/** @format */

import React from 'react';
import tw from 'twin.macro';
import styled from 'styled-components';
import { css } from 'styled-components/macro'; //eslint-disable-line
import { ReactComponent as FacebookIcon } from '../../images/facebook-icon.svg';
import { ReactComponent as TwitterIcon } from '../../images/twitter-icon.svg';
import { ReactComponent as YoutubeIcon } from '../../images/youtube-icon.svg';

const Container = tw.div`relative bg-footer -mb-8 px-6`;
const FiveColumns = tw.div`max-w-screen-xl mx-auto py-10 lg:py-20 flex flex-wrap justify-between`;

const Column = tw.div`md:w-1/5`;
const WideColumn = tw(Column)`text-center md:text-left w-full md:w-2/5 mb-10 md:mb-0`;

const ColumnHeading = tw.h5`font-bold text-text`;

const LinkList = tw.ul`mt-2 text-xs sm:text-sm text-gray-600 font-medium`;
const LinkListItem = tw.li`mt-3`;
const Link = tw.a`border-b-2`;

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;

const CompanyDescription = tw.p`mt-2 max-w-xs font-medium text-sm mx-auto md:mx-0 md:mr-4 text-gray-600  `;

const SocialLinksContainer = tw.div`mt-4 `;
const SocialLink = styled.a`
	${tw`cursor-pointer inline-block p-2 rounded-full bg-gray-700 text-gray-100 hover:bg-gray-900 transition duration-300 mr-4`}
	svg {
		${tw`w-4 h-4`}
	}
`;

const Footer = () => {
	return (
		<Container>
			<FiveColumns>
				<WideColumn>
					<LogoContainer>
						<ColumnHeading>Clerknox is a brand of:</ColumnHeading>
					</LogoContainer>
					<CompanyDescription>
						<span>FRESH START CREDIT INC </span>
						<br />
						<span>4310 West Grace Street,</span>
						<br />
						<span>Tampa, Florida 33607</span>
						<br />
						<span>Phone:(813) 540-2969</span>
						<br />
						Email :hello@renoix.com
					</CompanyDescription>
					<SocialLinksContainer>
						<SocialLink href="https://facebook.com">
							<FacebookIcon />
						</SocialLink>
						<SocialLink href="https://twitter.com">
							<TwitterIcon />
						</SocialLink>
						<SocialLink href="https://youtube.com">
							<YoutubeIcon />
						</SocialLink>
					</SocialLinksContainer>
				</WideColumn>
				<Column>
					<ColumnHeading>Quick Links</ColumnHeading>
					<LinkList>
						<LinkListItem>
							<Link href="#">How it Works</Link>
						</LinkListItem>
						<LinkListItem>
							<Link href="#">Pricing</Link>
						</LinkListItem>
						<LinkListItem>
							<Link href="#">Who We Are</Link>
						</LinkListItem>
					</LinkList>
				</Column>
				<Column>
					<ColumnHeading>Credit Repair</ColumnHeading>
					<LinkList>
						<LinkListItem>
							<Link href="#">For Buying a Car</Link>
						</LinkListItem>
						<LinkListItem>
							<Link href="#">For Buying a House</Link>
						</LinkListItem>
						<LinkListItem>
							<Link href="#">For Getting a Loan</Link>
						</LinkListItem>
						<LinkListItem>
							<Link href="#">For Shop credit</Link>
						</LinkListItem>
						<LinkListItem>
							<Link href="#">For Business</Link>
						</LinkListItem>
					</LinkList>
				</Column>
				<Column>
					<ColumnHeading>My Account</ColumnHeading>
					<LinkList>
						<LinkListItem>
							<Link href="#">Login/Sign Up</Link>
						</LinkListItem>
					</LinkList>
				</Column>
			</FiveColumns>
		</Container>
	);
};
export default Footer;
